export const getHost = () => {
    if (window.location.host.includes("localhost:3000")) {
        return "localhost:8080"
    }
    return window.location.host
}

export const getEnv = () => {
    if (window.location.host.includes("localhost:3000")) {
        return "http://localhost:8080"
    }
    return "https://api.nuraml.com"
}

export const formatEnvURL = (path) => {
    const env = getEnv()
    return `${env}/api/${path}`
}

export const websocketEndpoint = () => {
    if (window.location.host.includes("localhost")) {
        return 'ws://'
    }
    return 'wss://'
}